var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117 130",
    style: {
      enableBackground: "new 0 0 117 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:none;stroke:#1CADE4;stroke-width:14;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.82,35.39c0,30.41-14.53,57.42-37.01,74.47C36.17,92.82,21.54,65.71,21.54,35.19c0-0.48,0-0.96,0.02-1.43 C32.98,28.76,45.61,26,58.87,26c13.12,0,25.6,2.7,36.93,7.59C95.81,34.19,95.82,34.78,95.82,35.39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPure);
export default __webpack_public_path__ + "static/media/logo_pure.aed83a9e161a47b746ce5637447fbc1b.svg";
export { ForwardRef as ReactComponent };